import http from "../http-common";

class SupplierDataService {
  getAll() {
    return http.get("/suppliers");
  }

  get(id) {
    return http.get(`/suppliers/${id}`);
  }

  getByProject(id) {
    return http.get(`/suppliers/getByProject/${id}`);
  }

  create(data) {
    return http.post("/suppliers", data);
  }

  createBulk(data) {
    return http.post("/suppliers/bulk", data);
  }

  update(id, data) {
    return http.put(`/suppliers/${id}`, data);
  }

  delete(id) {
    return http.delete(`/suppliers/${id}`,);
  }

  deleteAll() {
    return http.delete(`/suppliers`, );
  }

  findByTitle(title) {
    return http.get(`/suppliers?title=${title}`,);
  }

  cloneProject(data) {
    return http.post("/suppliers/clone", data);
  }

}

export default new SupplierDataService();